import React from "react";
import styles from "./Home.module.css";
import { Article } from "../../components/article/Article";
import { Error, Loader, SectionTitle } from "../../components";
import { WelcomeWord } from "../../components/welcome-word/WelcomeWord";

const HomeUI = ({ articles, loading, error }) => {
  return (
    <div className={styles.home}>
      <WelcomeWord />
      <SectionTitle title="Recent News" />
      {error && <Error errorMessage={error} />}
      {loading && <Loader />}

      <div className={styles.articles_layout}>
        {articles &&
          articles.slice(0, 12).map((article) => (
            <Article key={article.slug} article={article} articleType="main" />
          ))}
      </div>
    </div>
  );
};

export default HomeUI;
